import { CheckIcon, RepeatIcon } from '@chakra-ui/icons';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { FileUploadingStatus } from 'enums/shared/fileUploadingStatus';
import { FC } from 'react';

export interface ChatUploadingFileThumbnailProps {
  status: FileUploadingStatus;
  repeat: () => void;
}

const ChatUploadingFileThumbnail: FC<ChatUploadingFileThumbnailProps> = ({
  status,
  repeat,
}) => {
  const icons = {
    [FileUploadingStatus.uploaded]: <CheckIcon />,
    [FileUploadingStatus.failed]: <RepeatIcon />,
    [FileUploadingStatus.uploading]: <Spinner />,
  };

  let content = (
    <Center width={8} height={8}>
      {icons[status]}
    </Center>
  );

  if (status === FileUploadingStatus.failed) {
    content = (
      <Box onClick={repeat} cursor="pointer">
        {content}
      </Box>
    );
  }

  return content;
};

export default ChatUploadingFileThumbnail;
